import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IChatbot } from "../../../Components/Chatbot/IChatbot";

export const WritingChatbotSlicer = createSlice({
  name: "WritingChatbotSlicer",
  initialState: {
    data: { data: [] },
    isLoading: false,
  } as IReduxState<{ user: string; message: string }[]>,
  reducers: {
    writingchatbotStart: (state, action: PayloadAction<IChatbot>) => {
      state.isLoading = true;
      state.data?.data?.push({
        user: "user",
        message: String(action.payload.chat),
      });
    },
    successWritingChatbot: (state, action) => {
      state.isLoading = false;
      state.data?.data?.push({ user: "chatbot", message: action.payload });
    },
    failureWritingChatbot: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearWritingChatbot: (state) => {
      state.data = { data: [] };
    },
  },
});

export const {
  writingchatbotStart,
  successWritingChatbot,
  failureWritingChatbot,
  clearWritingChatbot,
} = WritingChatbotSlicer.actions;

export default WritingChatbotSlicer.reducer;
